module.exports = __webpack_public_path__ + "affa1860efa910013d725dff6a2b5265.svg";